import styled from 'styled-components';
import { PlayLinkContainer } from '../../../../../components/Link';
import { device } from '../../../../breakpoints';
import {
    extraLightCoolGrey,
    regularWhite,
    fontWeightBold,
    playTransitionEasing,
    iconArrowRight,
} from '../../../../design-tokens';
import { PlayFocus } from '../../../../utils.styles';
import { playFontIcon, playFontSize } from '../../../../typography/helpers';
import PlayText from '../../../../typography/PlayText/PlayText';
import { PlayLinkDiscreet } from '../../../../PlayLink.styles';

export const InfoPopoutContainer = styled.div`
    ${PlayFocus}
    overflow: hidden;
    opacity: 0;
    height: 0;

    &.enter-done {
        opacity: 1;
        ${(props) => props.height && `height: ${props.height}px`};
        transition: opacity 300ms ease-in, height 300ms ease-out;
    }

    &.exit {
        opacity: 1;
        ${(props) => props.height && `height: ${props.height}px`};
    }

    &.exit-active {
        opacity: 0;
        height: 0;
        transition: opacity 300ms ease-in, height 300ms ease-in;
    }
`;

export const Description = styled(PlayText)`
    color: ${extraLightCoolGrey};
    margin-top: 10px;
    ${playFontSize(1.6)};
    line-height: 1.4;

    &:focus {
        outline: none;
    }
`;

export const MoreInfoLink = styled(PlayLinkContainer)`
    ${PlayLinkDiscreet};
    ${PlayFocus}
    ${playFontSize(1.3)};
    font-weight: ${fontWeightBold};
    color: ${regularWhite};
    margin-top: 20px;
    display: inline-block;

    &:after {
        ${playFontIcon(1.3, iconArrowRight)}

        line-height: normal;
        text-decoration: none;
        margin-left: 5px;
        transition: transform 200ms ${playTransitionEasing};
        margin-top: -1px;
        /* transform: translateZ(0); */
    }

    &:hover {
        text-decoration: underline;
        cursor: pointer;

        &:after {
            transform: translateX(4px);
        }
    }
`;

export const TruncatedLinkText = styled.span`
    display: none;

    @media ${device.GteSmall} {
        display: inline;
    }
`;
